import { Component, OnInit } from '@angular/core';
import { WidgetBaseComponent } from '../../widget-base/widget-base.component';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'app-widget-text',
    imports: [CommonModule],
    templateUrl: './widget-text.component.html',
    styleUrls: ['./widget-text-base.component.scss']
})

export class WidgetTextBaseComponent extends WidgetBaseComponent implements OnInit {
  public message: string | undefined;
  public messageLong: string | undefined;
  public isCollapsible: boolean | undefined;
  public showLongText: boolean | undefined;
  public id: string | undefined;
  public cssClass: string | undefined;
  public marginTop: string | undefined;
  public marginRight: string | undefined;
  public marginBottom: string | undefined;
  public marginLeft: string | undefined;

  public ngOnInit(): void {
    this.showLongText = false;
    this.isCollapsible = this.widget?.contentWidgetAttributeList?.find(a => a.key?.localeCompare("IsCollapsible") == 0)?.value == "true" ? true : false;
    this.message = this.widget?.contentWidgetAttributeList?.find(a => a.key?.localeCompare("Message") == 0)?.value;
    this.messageLong = this.widget?.contentWidgetAttributeList?.find(a => a.key?.localeCompare("MessageLong") == 0)?.value;
    this.id = this.widget?.contentWidgetAttributeList?.find(a => a.key?.localeCompare("Id") == 0)?.value;
    this.id = this.widget?.contentWidgetAttributeList?.find(a => a.key?.localeCompare("Id") == 0)?.value;
    if (this.id && this.id.includes(' ')) {
      this.id = this.id.split(' ')[0];
    }
    this.cssClass = this.widget?.contentWidgetAttributeList?.find(a => a.key?.localeCompare("CssClass") == 0)?.value;
    this.marginTop = this.widget?.contentWidgetAttributeList?.find(a => a.key?.localeCompare("MarginTop") == 0)?.value;
    this.marginRight = this.widget?.contentWidgetAttributeList?.find(a => a.key?.localeCompare("MarginRight") == 0)?.value;
    this.marginBottom = this.widget?.contentWidgetAttributeList?.find(a => a.key?.localeCompare("MarginBottom") == 0)?.value;
    this.marginLeft = this.widget?.contentWidgetAttributeList?.find(a => a.key?.localeCompare("MarginLeft") == 0)?.value;
  }

  public collapseTextClick() {
    if (this.isCollapsible) {
      this.showLongText = !this.showLongText;
    }
  }

}
